import type { TFunction } from 'i18next';
import type { DropdownOption } from '../shared/TailwindComponents/Dropdown';

/**
 * Matter categories as dropdown options (F-CATS).
 *
 * Categories are grouped by practice area (`parent_id`), so pickers render
 * them with `hierarchical` - Employment › Dismissal & termination - and search
 * matches either level. Names come from a static table in English and are
 * translated here; one mapping so the wizard, the edit form and the economics
 * filter can't drift apart.
 */
export const toCategoryOptions = (rows: any[], t: TFunction): DropdownOption[] =>
  (rows || []).map((cat: any) => {
    const name = String(cat.name || cat.category_name || '');
    return {
      value: String(cat.id || cat.category_id || ''),
      id: String(cat.id || cat.category_id || ''),
      label: name ? t(name) : '',
      parent_id: cat.parent_id != null ? String(cat.parent_id) : null,
      sort_order: cat.sort_order ?? undefined,
    };
  });

/** True once there are enough categories that grouping helps. */
export const hasCategoryGroups = (options: DropdownOption[]) => options.some((o) => o.parent_id);
